// ES5 compatibility exports
// This package is only exporting types

// ES5/ES6 Enum exports

const enums = {
  Brand: {
    Primary: 'primary',
    Secondary: 'secondary',
    Financing: 'financing',
    Yield: 'yield',
  },
  Size: {
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
  },
  ExtraSize: {
    Tiny: 'tiny',
    XLarge: 'x-large',
  },
  Status: {
    Default: 'default',
    Error: 'error',
    Warning: 'warning',
    Success: 'success',
  },
  VerticalAlignment: {
    Default: 'default',
    Top: 'top',
    Middle: 'middle',
    Bottom: 'bottom',
    Stretch: 'stretch',
  },
  HorizontalAlignment: {
    Default: 'default',
    Start: 'start',
    End: 'end',
    Around: 'around',
    Between: 'between',
    Even: 'even',
  },
}

const validator = {
  brand: value => Object.values(enums.Brand).includes(value),
  size: value => Object.values(enums.Size).includes(value),
  extraSize: value => Object.values({ ...enums.Size, ...enums.ExtraSize }).includes(value),
  status: value => Object.values(enums.Status).includes(value),
  verticalAlignment: value => Object.values(enums.VerticalAlignment).includes(value),
  horizontalAlignment: value => Object.values(enums.HorizontalAlignment).includes(value),
  custom: type => value => Object.values(type).includes(value),
}

const tools = {
  styleSize: raw => {
    switch (typeof raw) {
      case 'number':
        return `${raw}px`
      case 'string':
        return raw
      default:
        return undefined
    }
  },
}

module.exports = {
  __esModule: true,
  default: enums,
  Educts: enums,
  validator,
  tools,
}
